module.exports = __webpack_public_path__ + "0b25f603a8986e85467a6daa784cb397.png";